import Request from './Request';
import { invalidateChannelCache } from '../../pages/Dashboard/components/channelCache';

export interface IChannel {
    id: number;
    channelName: string;
    color: string;
}

export interface IManagedChannel {
    id: number;
    name: string;
    order: number | null;
    typeId: number;
    active: boolean;
    channelTypeName: string;
    channelTypeSlug: string;
    channelTypeActive: boolean;
}

export interface IChannelInput {
    name: string;
    typeId: number;
    order?: number;
}

export interface IChannelWriteResponse {
    id: number;
    name: string;
    order: number | null;
    typeId: number;
    active: boolean;
}

export interface IChannelToggleResponse {
    id: number;
    active: boolean;
}

export interface IChannelReorderInput {
    typeId: number;
    orderedIds: number[];
}

const _allCache = new Map<string, Promise<IChannel[]>>();

export function clearChannelCache() {
    _allCache.clear();
}

class Channel {
    static GetAll = (channelType: string): Promise<IChannel[]> => {
        if (!_allCache.has(channelType)) {
            const promise = Request.DoGet(`channel/${channelType}/all`) as unknown as Promise<IChannel[]>;
            _allCache.set(channelType, promise);
            promise.catch(() => _allCache.delete(channelType));
        }
        return _allCache.get(channelType)!;
    };

    static GetManagement = (): Promise<IManagedChannel[]> => {
        return Request.DoJson<IManagedChannel[]>('channel/management');
    };

    static Create = async (data: IChannelInput): Promise<IChannelWriteResponse> => {
        const response = await Request.DoJson<IChannelWriteResponse>('channel', 'POST', data);
        clearChannelCache();
        invalidateChannelCache();
        return response;
    };

    static Update = async (id: number, data: IChannelInput): Promise<IChannelWriteResponse> => {
        const response = await Request.DoJson<IChannelWriteResponse>(`channel/${id}`, 'PUT', data);
        clearChannelCache();
        invalidateChannelCache();
        return response;
    };

    static ToggleActive = async (id: number): Promise<IChannelToggleResponse> => {
        const response = await Request.DoPatch<IChannelToggleResponse>(`channel/${id}/toggle-active`);
        clearChannelCache();
        invalidateChannelCache();
        return response;
    };

    static Reorder = async (data: IChannelReorderInput): Promise<IManagedChannel[]> => {
        const response = await Request.DoJson<IManagedChannel[]>('channel/reorder', 'PUT', data);
        clearChannelCache();
        invalidateChannelCache();
        return response;
    };
}

export default Channel;
